import api from "../api";

export const authService = {
  me: async () => (await api.get("/auth/me")).data,
  login: async (email, password) => {
    const form = new URLSearchParams({ username: email, password });
    return (await api.post("/auth/login", form)).data;
  },
  startRegistration: async (payload) => (await api.post("/auth/register/start", payload)).data,
  verifyRegistration: async (verificationId, code) => (
    await api.post("/auth/register/verify", { verification_id: verificationId, code })
  ).data,
  resendRegistration: async (verificationId) => (
    await api.post("/auth/register/resend", { verification_id: verificationId })
  ).data,
  logout: async () => api.post("/auth/logout"),
};
